export const manualNumericFacetSelector = (state, facetId) => state.manualNumericFacetSet[facetId]?.manualRange;
